module.exports = __webpack_public_path__ + "static/media/logo-careers.141d79f4.svg";